import * as React from 'react'
import styles from './AuthLayout.module.css'

interface AuthLayoutProps {
  headline: string
  subtext: string
  children: React.ReactNode
  footer?: React.ReactNode
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ headline, subtext, children, footer }) => {
  return (
    <div className={styles.page}>
      <div className={styles.brandPanel}>
        <div className={styles.brandTop}>
          <span className={styles.brandMarkBadge}>
            <img className={styles.brandMark} src='/assets/icon/engage.jpg' alt='' />
          </span>
          <span className={styles.brandWordmark}>Engage</span>
        </div>
        <div className={styles.brandMid}>
          <p className={styles.brandHeadline}>Manage patients and assessments, all in one portal.</p>
        </div>
        <div className={styles.brandFoot}>© Engage. All Rights Reserved.</div>
      </div>

      <div className={styles.formPanel}>
        <div className={styles.formCard}>
          <h1 className={styles.formHeadline}>{headline}</h1>
          <p className={styles.formSub}>{subtext}</p>
          {children}
          {footer && <div className={styles.formFooter}>{footer}</div>}
        </div>
      </div>
    </div>
  )
}
